import { Checkbox, CheckboxGroup, FormControl, FormHelperText, FormLabel, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { ViewDocumentAsOwnerDto } from "../../autogen/bff-api";
import { attachmentDetails } from "../../common/documents/attachmentDetails";

interface Props {
  attachments: ViewDocumentAsOwnerDto[];
  chosen: string[];
  onChange: (chosen: string[]) => void;
}

export const NeedAttachmentChoice = ({ attachments, chosen, onChange }: Props) => {
  const { t } = useTranslation();
  if (attachments.length === 0) return null;
  return (
    <FormControl as="fieldset">
      <FormLabel as="legend">{t("Attachments to bring along")}</FormLabel>
      <CheckboxGroup value={chosen} onChange={(next) => onChange(next.map(String))}>
        <Stack spacing="2">
          {attachments.map((attachment) => (
            <Checkbox key={attachment.id} value={attachment.id}>
              <Text as="span" wordBreak="break-word">
                {attachment.name}
              </Text>{" "}
              <Text as="span" color="smMuted" fontSize="sm" whiteSpace="nowrap">
                {`· ${attachmentDetails(attachment)}`}
              </Text>
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
      <FormHelperText>
        {t(
          "The ones you choose are copied into the procurement's documents, which suppliers see once it is published. The rest stay on the need, where you can open them from the procurement.",
        )}
      </FormHelperText>
    </FormControl>
  );
};
